<ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown d-md-down-none">
        <a class="nav-link" [routerLink]="['/email']" style="cursor:pointer; user-select: none;">
            <i class="fa fa-envelope"></i>
            <span class="badge badge-primary">{{notificationCount | async}}</span>
        </a>
    </li>
</ul>
